import styled, { css, keyframes } from 'styled-components';
import { Form as unformForm } from '@unform/web';

const bgDark = '#121212';
const cardDark = '#1E1E1E';
const textLight = '#EAEAEA';
const textSecondary = '#A0A0A0';
const border = 'rgba(255,255,255,0.1)';
const green = '#1DB954';
const amber = '#FFC107';
// const red = '#c80800';
const red = '#dc3545';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: ${bgDark};
  color: ${textLight};
  align-items: center;
  width: 100%;
  overflow-x: hidden;
  * {
    box-sizing: border-box;
  }
`;

export const Form = styled(unformForm)`
  width: 100%;
  max-width: 1080px;
  margin: 120px auto 0 auto;
  display: flex;
  position: relative;

  div {
    input {
      background: ${bgDark};
      color: ${textLight};
      border-radius: 8px;
    }
  }
`;

const appear = keyframes`
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
`;

export const Content = styled.div`
  width: 100%;
  max-width: 1080px;
  margin: 24px auto 40px auto;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 16px;

  @media (min-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  @media (min-width: 1024px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;

export const StatCard = styled.div`
  background: ${cardDark};
  border: 1px solid ${border};
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  animation: ${appear} 0.3s ease both;
`;

export const StatLabel = styled.div`
  font-size: 14px;
  color: ${textSecondary};
`;

export const StatValue = styled.div<{ color?: 'green' | 'amber' | 'red' }>`
  font-size: 28px;
  font-weight: 700;
  ${(p) =>
    p.color === 'green' &&
    css`
      color: ${green};
    `}
  ${(p) =>
    p.color === 'amber' &&
    css`
      color: ${amber};
    `}
  ${(p) =>
    p.color === 'red' &&
    css`
      color: ${red};
    `}
`;

export const Sections = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const SectionTitle = styled.h2`
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.015em;
  padding: 16px 8px 0 8px;
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;

  @media (min-width: 1024px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const Card = styled.div`
  background: ${cardDark};
  border: 1px solid ${border};
  border-radius: 12px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const CardTitle = styled.div`
  font-size: 18px;
  font-weight: 700;
`;

export const ProgressBar = styled.div`
  width: 100%;
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: 10px;
  border-radius: 9999px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
`;

export const ProgressFill = styled.div<{ color?: 'green' | 'amber' | 'red' }>`
  height: 10px;
  border-radius: 9999px;
  ${(p) =>
    p.color === 'green' &&
    css`
      background: ${green};
    `}
  ${(p) =>
    p.color === 'amber' &&
    css`
      background: ${amber};
    `}
  ${(p) =>
    p.color === 'red' &&
    css`
      background: ${red};
    `}
`;

export const CardMeta = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  font-size: 14px;

  @media (max-width: 420px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const MetaItem = styled.div`
  display: flex;
  gap: 6px;
`;

export const MetaLabel = styled.span`
  color: ${textSecondary};
`;

export const MetaValue = styled.span`
  color: ${textLight};
  font-weight: 500;
`;

export const EmptyState = styled.div`
  padding: 12px 8px;
  color: ${textSecondary};

  a {
    color: ${amber};
    text-decoration: underline;
  }
`;
